import React from 'react';
import styles from './SocialLinks.module.css';

// Импортируем SVG напрямую для Vite
import GithubIcon from '../../assets/icons/github.svg?react';
import TelegramIcon from '../../assets/icons/telegram.svg?react';
import EmailIcon from '../../assets/icons/email.svg?react';
import LinkedinIcon from '../../assets/icons/linkedin.svg?react';
import VkIcon from '../../assets/icons/vk.svg?react';
import InstagramIcon from '../../assets/icons/instagram.svg?react';
import XIcon from '../../assets/icons/x.svg?react';

const iconMap = {
  github: GithubIcon,
  telegram: TelegramIcon,
  email: EmailIcon, // Kept email in case it's used elsewhere, but it's not in the profileData links now.
  linkedin: LinkedinIcon,
  vk: VkIcon,
  instagram: InstagramIcon,
  x: XIcon,
};

const SocialLinks = ({ links }) => {
  return (
    <div className={styles.socialLinks}>
      {links.map((link, index) => {
        const IconComponent = iconMap[link.platform];

        return (
          <a
            key={index}
            href={link.url}
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.label}
          >
            {IconComponent && <IconComponent className={styles.icon} />}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;